/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import * as hui from '@travelnest/hui';
import { Link } from 'react-router-dom';
import { toggleFreshChatWidget } from '../../../view/components/freshchat/FreshChatWidget';

const MoreWrapper = styled.div`
	padding: ${hui.theme.spacing.space40};

	@media only screen and (min-width: ${hui.theme.breakpoints.md.min}) {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
`;

const Card = styled.div`
	margin: 0 0 ${hui.theme.spacing.space40};
	padding: ${hui.theme.spacing.space30} ${hui.theme.spacing.space20};
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	border: 1px solid rgba(5, 42, 128, 0.1);
	border-radius: ${hui.theme.radii.radii40};

	@media only screen and (min-width: ${hui.theme.breakpoints.md.min}) {
		flex-grow: 1;
		flex-basis: calc(50% - ${hui.theme.spacing.space40});
		&:nth-child(2n) {
			margin-left: ${hui.theme.spacing.space40};
		}
	}
`;

const Item = css`
	color: ${hui.theme.colors.BB200};
	display: flex;
	flex-direction: row;
	align-items: center;
	text-decoration: none;
	padding: ${hui.theme.spacing.space20} ${hui.theme.spacing.space30};
	width: 100%;

	& > div {
		margin-right: ${hui.theme.spacing.space30};
	}

	.svg-active-state {
		display: none;
	}
`;

export default () => {
	return <>
		<hui.NavigationBar title="More" />

		<MoreWrapper>
			<Card>
				<a css={Item} href="/direct"><hui.Icon name="Nav.Direct" /> Direct</a>
				<a css={Item} href="/properties"><hui.Icon name="Nav.Properties" /> Properties</a>
				<a css={Item} href="/channels"><hui.Icon name="Nav.FeesAndChannels" />Channels</a>
				<Link css={Item} to="/property-scores"><hui.Icon name="Nav.Score" /> Property Score</Link>
			</Card>

			<Card>
				{
					window.fcWidget &&
					<a css={Item} onClick={(e) => { toggleFreshChatWidget(); e.preventDefault(); }}><hui.Icon name="Nav.ChatToUs" /> Chat to us</a>
				}
				<a css={Item} href="https://travelnest.freshdesk.com/support/home" target="_blank"><hui.Icon name="Nav.Support" /> Help & Support</a>
				<a css={Item} href="/account"><hui.Icon name="Nav.Account" /> My Account</a>
				<Link css={Item} to="/logout"><hui.Icon name="Nav.LogOut" /> Log out</Link>
			</Card>
		</MoreWrapper>
	</>;
};
